import React, { Component } from 'react';
import '../../../styles/scss/style.css';

//Components
import ItemBlock from '../molecules/ItemBlock/ItemBlockContainer';
import TextHeadingOne from '../atoms/TextHeadingOne';
import TextParagraph from '../atoms/TextParagraph';
// import DashboardPanelMenu from '../molecules/DashboardPanelMenu';

//Returning the component
class FacebookPages extends Component {
	render() {
		return (
			<div className="dashboardPanelContainer">
				<div className="dashboardPanel">
    				{/* <DashboardPanelMenu text='Menu' href='#' /> */}
					<div className="dashboardPanel__content">
						<div className="dashboardPanel__mainContent">
							<TextHeadingOne text={this.props.data.heading} />
							<TextParagraph text={this.props.data.text} />
							{ this.props.pages.map((page, i) => {
                                return <ItemBlock key={i} classTypeIcon="fa-facebook-official facebook" pageData={page} />
							})}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default FacebookPages;





// WEBPACK FOOTER //
// ./src/redux/components/organisms/FacebookPages.jsx